// extracted by mini-css-extract-plugin
export default {"App":"App_App__j-3+O","App__logo":"App_App__logo__4Anzd"};